"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateQuery = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class DateQuery extends base_models_1.Serializable {
}
exports.DateQuery = DateQuery;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)({ name: 'agreement_date' }),
    (0, base_models_1.Docs)({
        description: 'date when the charging station was installed (yyyy-mm-dd, needs zero-padding and needs to be after 26 October 2022)',
        example: '2022-12-09',
    }),
    tslib_1.__metadata("design:type", String)
], DateQuery.prototype, "agreementDate", void 0);
